import { LoginForm } from '@/features/auth/components/LoginForm';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const loginSearchSchema = z.object({
  error: z.string().optional(),
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_auth/login')({
  validateSearch: loginSearchSchema,
  component: LoginForm,
});
